const pt = {
  // Nav
  nav_home: 'Início',
  nav_products: 'Produtos',
  nav_about: 'Sobre Nós',
  nav_contact: 'Contato',
  nav_explore: 'Explorar',

  // Hero
  hero_badge: 'Arranhadores · Qualidade Profissional',
  hero_title1: 'Vivendo com Gatos',
  hero_title2: 'Cada Arranhão',
  hero_title3: 'É um Ritual de Alegria',
  hero_desc: 'Materiais naturais premium combinados com design ergonômico — ajudando gatos a amarem seus arranhadores e tornando sua casa mais bonita. Koorpet, protegendo a felicidade por trás de cada pegada.',
  hero_btn_products: 'Explorar Produtos',
  hero_btn_about: 'Nossa História',
  hero_stat1_num: '6+',
  hero_stat1_label: 'Anos no Setor',
  hero_stat2_num: '50+',
  hero_stat2_label: 'Linhas de Produtos',
  hero_stat3_num: '100K+',
  hero_stat3_label: 'Gatos Confiam em Nós',
  hero_scroll: 'Rolar para Baixo',

  // Featured Products
  featured_label: 'Produtos em Destaque',
  featured_title: 'Mais Vendidos',
  featured_subtitle: 'Coleção Favorita dos Gatos',
  featured_view_all: 'Ver Todos os Produtos',
  featured_empty: 'Nenhum produto em destaque ainda',

  // Features Section
  features_badge: 'Vantagens',
  features_title: 'Por que Escolher Koorpet',
  features_desc: 'Cada produto passa por rigorosos testes de P&D para oferecer aos gatos a melhor experiência de arranhar',
  feature1_title: 'Alta Densidade Tripla Camada',
  feature1_desc: 'Papelão ondulado premium com tecnologia de prensagem a quente tripla, 2x mais denso que produtos comuns, mais durável e duradouro.',
  feature2_title: 'Infusão Natural de Catnip',
  feature2_desc: 'Catnip orgânico infundido uniformemente entre as camadas de papelão, liberando fragrância natural duradoura que atrai os gatos.',
  feature3_title: 'Certificação Eco Não-Tóxica',
  feature3_desc: 'Todos os materiais passam por testes ambientais nacionais — sem formaldeído, sem metais pesados, seguro mesmo se os gatos morderem.',
  feature4_title: 'Design Ergonômico',
  feature4_desc: 'Baseado em pesquisas sobre comportamento felino, ângulos e alturas otimizados que combinam perfeitamente com a postura natural de arranhar dos gatos.',

  // Brand Section
  brand_label: 'Artesanato Dedicado',
  brand_title1: 'Artesanato Dedicado',
  brand_title2: 'Por Um Arranhador Perfeito',
  brand_desc: 'Fundada em 2024, a Koorpet é uma marca líder dedicada à P&D e produção de arranhadores na China. Nossa fábrica abrange 4.000 metros quadrados com linhas de produção totalmente automatizadas e capacidade anual de 2 milhões de unidades. Acreditamos que um bom arranhador não só protege os móveis, mas também melhora a qualidade de vida dos gatos.',
  brand_years_num: '2024',
  brand_years_label: 'Fundada Em',
  brand_years_desc: 'Com uma fábrica moderna de 4.000 m² e linhas de produção totalmente automatizadas, fornecendo arranhadores de alta qualidade para famílias de gatos em todo o mundo.',
  brand_cert1_label: 'Cert. Nacional de Qualidade',
  brand_cert1_sub: 'Certificado ISO 9001',
  brand_cert2_label: 'Materiais Eco Naturais',
  brand_cert2_sub: 'Certificado Não-Tóxico',
  brand_cert3_label: 'Exportação para 10+ Países',
  brand_cert3_sub: 'Padrões Internacionais',
  brand_cert4_label: '100K+ Gatos',
  brand_cert4_sub: 'Escolha Confiável',
  brand_cta: '',

  // CTA Section
  cta_quote_label: 'Voz dos Donos de Gatos',
  cta_quote: '"Desde que usei Koorpet, meu sofá está finalmente seguro!"',
  cta_label: 'Agir Agora',
  cta_title1: 'Deixe Seu Gato Amar',
  cta_title2: 'Seu Próprio Território',
  cta_desc: 'Mais de 100 mil gatos já escolheram Koorpet. Materiais naturais, design cuidadoso, controle de qualidade rigoroso — cada produto é o melhor presente para o seu gato. Peça agora e aproveite a qualidade de vida.',
  cta_btn: 'Comprar Agora',

  // Reviews Section
  reviews_title: 'Avaliações Reais de Donos de Gatos:',
  reviews_subtitle: 'Avaliações genuínas de donos de gatos em todo o país',
  review1_name: 'Mamãe do Gato Laranja',
  review1_content: 'Comprei a Série Nuvem e meu gato laranja se apaixonou no primeiro dia! Qualidade excelente, papelão grosso e resistente, o cheiro de catnip o atrai muito. Super recomendo!',
  review1_product: 'Arranhador Série Nuvem',
  review2_name: 'Dono de Ragdoll',
  review2_content: 'O Poste de Sisal é artesanalmente bem feito, a corda de sisal está enrolada firmemente, a base é muito estável. Meu ragdoll arranha nele todos os dias, o sofá está finalmente salvo!',
  review2_product: 'Poste de Sisal para Gatos',
  review3_name: 'Humana da Gata Tricolor',
  review3_content: 'O Arranhador Ondulado tem um design inteligente, reversível para o dobro da durabilidade, custo-benefício incrível. Minha gata adora deitar nele para dormir, dois em um!',
  review3_product: 'Arranhador Ondulado para Gatos',
  review4_name: 'Pai do British Shorthair',
  review4_content: 'Embalagem muito cuidadosa, qualidade do produto impecável. Atendimento ao cliente muito ágil, respostas instantâneas. Já recomprei três vezes, é a marca favorita do meu gato!',
  review4_product: 'Arranhador Redondo com Catnip',

  // About Banner
  about_breadcrumb_home: 'Início',
  about_breadcrumb_about: 'Sobre Nós',
  about_banner_title: 'Sobre Koorpet',
  about_banner_desc: 'Artesanato e qualidade, dedicados à felicidade de cada gato. Acreditamos que ótimos produtos tornam o vínculo entre pessoas e pets ainda mais bonito.',

  // Company Stats
  stat1_num: '2024',
  stat1_label: 'Fundada',
  stat1_sub: 'Profunda no setor pet',
  stat2_num: '50+',
  stat2_label: 'Produtos',
  stat2_sub: 'Cobrindo todos os cenários felinos',
  stat3_num: '100K+',
  stat3_label: 'Gatos',
  stat3_sub: 'Confiam na Koorpet',
  stat4_num: '30+',
  stat4_label: 'Patentes',
  stat4_sub: 'Inovação contínua',

  // Brand Story
  story_label: 'Nossa História',
  story_float_num: '2024',
  story_float_desc: 'Profunda no setor de arranhadores, focada em qualidade e inovação',
  story_title1: 'De Um Arranhador',
  story_title2: 'ao Nascimento de uma Marca',
  story_p1: 'Fundada em 2024, a Koorpet é uma marca líder dedicada à P&D e produção de arranhadores na China. Operamos uma fábrica moderna de 4.000 metros quadrados com linhas de produção totalmente automatizadas e capacidade anual de 2 milhões de unidades.',
  story_p2: 'Com anos de experiência no setor pet, nosso fundador reconheceu a falta de produtos no mercado que realmente buscam qualidade e design de experiência do usuário. Determinado a criar a Koorpet, ele se propôs a redefinir o arranhador com padrões mais elevados.',
  story_p3: 'Da seleção de matérias-primas ao produto final, cada processo passa por rigoroso controle de qualidade. Seguimos a filosofia de "materiais naturais, design cuidadoso, controle de qualidade rigoroso", dedicados a proporcionar a melhor experiência de arranhar para cada gato. Hoje, a Koorpet se tornou uma marca confiável de arranhadores, com produtos vendidos em muitos países e regiões.',
  story_founder_name: 'John Yu',
  story_founder_role: 'Fundador da Koorpet',
  story_founder_quote: '"Não fazemos apenas arranhadores — criamos um espaço de convivência melhor para cada família de gatos."',

  // Timeline
  timeline_label: 'Marcos',
  timeline_title: 'Nossa Jornada',
  timeline_desc: 'Da fabricação OEM à marca própria, cada passo é firme. Estas são as pegadas do crescimento da Koorpet.',
  milestone1_title: 'Lançamento do Negócio OEM',
  milestone1_desc: 'Iniciamos serviços de fabricação OEM de arranhadores para marcas internacionais de pets, estabelecendo bases de cadeia de suprimentos e construindo expertise em produção e controle de qualidade.',
  milestone2_title: 'Expansão da Fábrica',
  milestone2_desc: 'Expandimos uma fábrica moderna de 4.000 m², introduzimos linhas de produção totalmente automatizadas, com capacidade anual de 5 milhões de unidades.',
  milestone3_title: 'Avanço nas Exportações',
  milestone3_desc: 'Produtos OEM exportados para mais de 10 países e regiões, atendendo mais de 50 clientes internacionais, com qualidade reconhecida internacionalmente.',
  milestone4_title: 'Preparação da Marca',
  milestone4_desc: 'Montamos uma equipe independente de P&D, preparamos a marca própria Koorpet, concluímos o primeiro lote de designs originais de produtos e layout de patentes.',
  milestone5_title: 'Koorpet Estabelecida',
  milestone5_desc: 'A marca Koorpet foi oficialmente estabelecida, a primeira série de arranhadores de papelão ondulado de alta densidade foi lançada com grande recepção no mercado.',
  milestone6_title: 'Expansão da Linha de Produtos',
  milestone6_desc: 'Lançamos postes de sisal, série de árvores para gatos e outros novos produtos, obtivemos ISO 9001 e outras certificações internacionais, a influência da marca continuou a se expandir.',
  milestone7_title: 'Marco de Usuários',
  milestone7_desc: 'Atendemos mais de 100 mil famílias de gatos, a Koorpet se tornou uma marca líder de arranhadores na China, continuando a liderar o setor.',

  // Team Section
  team_label: 'Nossa Equipe',
  team_title: 'Equipe Principal',
  team_desc: 'Um grupo de verdadeiros amantes de gatos, criando cada produto com expertise e paixão',
  team_more: 'Mais',
  team_more2: 'membros apaixonados da equipe profissional Koorpet',
  team1_name: 'John Yu',
  team1_role: 'Fundador',
  team1_desc: 'Anteriormente diretor de canal em uma empresa líder do setor, com profundo conhecimento do mercado de produtos pet. Baseado em uma compreensão profunda do bem-estar felino e uma busca incansável pela qualidade do produto, fundou a Koorpet em 2024, liderando a equipe da fabricação OEM à marca própria.',
  team1_tag1: 'Fundação da Marca',
  team1_tag2: 'Expansão de Canais',
  team2_name: 'Lin Xiaowen',
  team2_role: 'Designer Chefe',
  team2_desc: 'Graduada pela Academia Central de Belas Artes em Design Industrial, 8 anos em design de produtos pet, liderou o design de aparência de mais de 30 produtos Koorpet.',
  team2_tag1: 'Design de Produto',
  team2_tag2: 'Experiência do Usuário',
  team3_name: 'Wang Jianguo',
  team3_role: 'Diretor de P&D',
  team3_desc: 'PhD em Engenharia de Materiais, 10 anos focado em P&D de materiais para produtos pet, liderou o desenvolvimento da fórmula de baixa poeira e do processo de infusão de catnip da Koorpet.',
  team3_tag1: 'P&D de Materiais',
  team3_tag2: 'Inovação de Processos',
  team4_name: 'Zhang Meiling',
  team4_role: 'Diretora de Qualidade',
  team4_desc: 'Possui certificação do sistema de gestão de qualidade ISO, responsável pelo controle de qualidade em todas as linhas de produtos Koorpet, garantindo que cada produto atenda aos padrões de fábrica.',
  team4_tag1: 'Controle de Qualidade',
  team4_tag2: 'Certificação ISO',

  // Certificates
  cert_label: 'Certificações',
  cert_title: 'Credenciais e Certificações',
  cert_desc: 'Múltiplas certificações de autoridade — a melhor prova da qualidade e inovação da Koorpet',
  cert1_title: 'ISO 9001',
  cert1_sub: 'Sistema de Gestão de Qualidade',
  cert1_desc: 'Certificação internacional do sistema de gestão de qualidade, processo de produção totalmente rastreável, qualidade garantida.',
  cert1_year: 'Obtida em 2018',
  cert2_title: 'Cert. Eco Não-Tóxico',
  cert2_sub: 'Teste Eco Nacional Aprovado',
  cert2_desc: 'Todos os materiais passam por testes ambientais nacionais — sem formaldeído, sem metais pesados, seguro mesmo se os gatos morderem.',
  cert2_year: 'Obtida em 2017',
  cert3_title: 'Cert. de Segurança Pet',
  cert3_sub: 'Associação Chinesa de Produtos Pet',
  cert3_desc: 'Certificação de segurança concedida pela Associação Chinesa de Produtos Pet, uma das poucas marcas do setor a receber esta certificação.',
  cert3_year: 'Obtida em 2019',
  cert4_title: 'Cert. CE Europeia',
  cert4_sub: 'Acesso ao Mercado da UE',
  cert4_desc: 'Certificação CE da UE aprovada, produtos atendem aos padrões de segurança, saúde e meio ambiente da UE, aptos para venda no mercado da UE.',
  cert4_year: 'Obtida em 2020',
  awards_title: 'Prêmios',
  award1_title: 'Prêmio de Design Inovador de Produtos Pet',
  award1_org: 'Expo da Indústria Pet da China',
  award2_title: 'Marca Mais Confiável pelos Donos de Gatos',
  award2_org: 'Seleção Anual Pet Home',
  award3_title: 'Reconhecimento como Empresa Nacional de Alta Tecnologia',
  award3_org: 'Departamento de Ciência e Tecnologia de Guangdong',
  award4_title: 'Marca Registrada Famosa de Guangdong',
  award4_org: 'Administração de Indústria e Comércio de Guangdong',
  award5_title: 'Empresa de Exportação de Qualidade em Produtos Pet',
  award5_org: 'Departamento de Comércio de Guangzhou',
  award6_title: 'Excelente PME de Guangzhou',
  award6_org: 'Departamento de Indústria e TI de Guangzhou',

  // About CTA
  about_cta_label: 'Junte-se a Nós',
  about_cta_title1: 'Juntos, Vamos Criar',
  about_cta_title2: 'Uma Vida Melhor para Gatos',
  about_cta_btn1: 'Explorar Produtos',
  about_cta_btn2: 'Fale Conosco',

  // Products Banner
  products_breadcrumb_home: 'Início',
  products_breadcrumb: 'Produtos',
  products_banner_title: 'Centro de Produtos',
  products_banner_desc: 'Materiais naturais premium, artesanalmente elaborados — cada arranhador feito para que os gatos amem seu ritual de arranhar',

  // Products CTA
  products_cta_title: 'Não Encontrou o Produto Certo?',
  products_cta_desc: 'Entre em contato conosco para soluções personalizadas para suas necessidades específicas',
  products_cta_btn: 'Fale Conosco',

  // Product Filter
  filter_all: 'Todos',
  filter_count: '',
  filter_count2: 'produtos encontrados',
  sort_default: 'Padrão',
  sort_price_asc: 'Preço: Menor para Maior',
  sort_price_desc: 'Preço: Maior para Menor',
  category_corrugated: 'Papelão',
  category_sisal: 'Sisal',
  category_combo: 'Combo',

  // Product Card
  product_view_detail: 'Ver Detalhes',

  // Product Detail
  detail_product_code: 'Código do Produto',
  detail_not_found: 'Produto não encontrado',
  detail_back_to_products: 'Voltar aos Produtos',

  // Tags
  tag_hot_selling: 'Mais Vendido',
  tag_new: 'Novo',
  tag_corrugated_paper: 'Papelão',
  tag_limited_offer: 'Oferta Limitada',
  tag_bestseller: 'Best-seller',
  tag_recommended: 'Recomendado',
  tag_catnip: 'Catnip',
  tag_sisal: 'Sisal',
  tag_corner_protector: 'Protetor de Canto',
  tag_cat_tree: 'Árvore para Gatos',
  tag_eco_friendly: 'Ecológico',

  detail_tab_desc: 'Descrição',
  detail_tab_specs: 'Especificações',
  detail_tab_faq: 'Perguntas Frequentes',
  detail_spec_material: 'Material',
  detail_spec_size: 'Tamanho',
  detail_spec_weight: 'Peso',
  detail_spec_moq: 'MOQ',
  detail_spec_suitable: 'Indicado Para',
  detail_spec_suitable_val: 'Todos os tamanhos',
  detail_spec_package: 'Conteúdo da Embalagem',
  detail_spec_package_val: 'Produto × 1, Manual × 1',

  detail_save: 'Economize ',
  detail_save_unit: '',
  detail_btn_consult: 'Consultar para Comprar',
  related_title: 'Você Também Pode Gostar',
  related_view_all: 'Ver Todos',

  // Highlight Titles
  highlight_title_triple_layer: 'Prensagem Tripla Camada',
  highlight_title_catnip_infused: 'Catnip Orgânico Infundido',
  highlight_title_eco_certified: 'Certificação Eco Não-Tóxica',
  highlight_title_anti_slip: 'Base Antiderrapante',
  highlight_title_natural_sisal: 'Sisal Natural',
  highlight_title_solid_wood: 'Base de Madeira Maciça',
  highlight_title_golden_height: 'Altura Ideal de 60cm',
  highlight_title_nail_care: 'Cuidado Natural das Unhas',
  highlight_title_double_sided: 'Dupla Face',
  highlight_title_wave_curve: 'Design Curvo Ondulado',
  highlight_title_low_dust: 'Fórmula de Baixa Poeira',
  highlight_title_rubber_strip: 'Tira de Borracha Antiderrapante',
  highlight_title_sofa_design: 'Projetado para Sofás',
  highlight_title_tool_free: 'Sem Ferramentas',
  highlight_title_sofa_safe: 'Não Danifica o Sofá',
  highlight_title_set_of_4: 'Conjunto com 4',
  highlight_title_catnip_builtin: 'Catnip Embutido',
  highlight_title_round_design: 'Design Redondo Elegante',
  highlight_title_safe_edge: 'Bordas com Acabamento Seguro',
  highlight_title_hot_seller: 'Campeão de Vendas',
  highlight_title_three_level: 'Plataforma de Três Níveis',
  highlight_title_15kg_capacity: 'Suporta 15kg+',
  highlight_title_hanging_toy: 'Brinquedo Suspenso',
  highlight_title_wide_base: 'Base Ampla e Estável',

  // Highlight Descriptions
  highlight_desc_triple_layer: '2x mais denso que produtos comuns, mais durável',
  highlight_desc_catnip_infused: 'Aroma duradouro, atrai os gatos naturalmente',
  highlight_desc_eco_certified: 'Seguro mesmo se morderem',
  highlight_desc_anti_slip: 'Fica firme no lugar durante o uso',
  highlight_desc_natural_sisal: 'Enrolado à mão, uniforme e resistente',
  highlight_desc_solid_wood: 'Pinho tratado, estável e não tomba',
  highlight_desc_golden_height: 'Atende à necessidade de alongamento dos gatos',
  highlight_desc_nail_care: 'Afia as unhas eficazmente, protege os móveis',
  highlight_desc_double_sided: 'Vire e continue usando, o dobro de vida útil',
  highlight_desc_wave_curve: 'Adapta-se à postura natural de arranhar',
  highlight_desc_low_dust: 'Poucos resíduos, mantém a casa limpa',
  highlight_desc_sofa_design: 'Ajuste perfeito nos cantos do sofá, proteção total',
  highlight_desc_tool_free: 'Velcro forte, pronto em 30 segundos',
  highlight_desc_sofa_safe: 'Camada protetora traseira, sem marcas',
  highlight_desc_set_of_4: 'Protege os quatro cantos do sofá de uma vez',
  highlight_desc_catnip_builtin: 'Resolve o problema de gatos que ignoram o arranhador',
  highlight_desc_round_design: 'Uso plano ou na parede, dois em um',
  highlight_desc_safe_edge: 'Sem rebarbas, seguro para gatos',
  highlight_desc_hot_seller: 'Mais de 5000 vendidos por mês, muito bem avaliado',
  highlight_desc_three_level: 'Satisfaz o amor dos gatos por alturas',
  highlight_desc_15kg_capacity: 'Adequado para lares com vários gatos',
  highlight_desc_hanging_toy: 'Estimula o interesse dos gatos em brincar',
  highlight_desc_wide_base: 'Não tomba mesmo ao pular',

  // Additional Tags
  tag_double_sided: 'Dupla Face',
  tag_sofa_protector: 'Protetor de Sofá',
  tag_multi_function: 'Multifuncional',

  // Contact Banner
  contact_breadcrumb_home: 'Início',
  contact_breadcrumb: 'Contato',
  contact_banner_title: 'Fale Conosco',
  contact_banner_desc: 'Seja para consultas sobre produtos, cooperação comercial ou serviço pós-venda, estamos sempre prontos para ajudar',

  // Contact Form
  contact_form_label: 'Enviar Mensagem',
  contact_form_title: 'Deixe-nos uma Mensagem',
  contact_form_desc: 'Preencha o formulário abaixo e responderemos em 1 dia útil',
  contact_form_success_title: 'Mensagem Enviada!',
  contact_form_success_desc: 'Obrigado pela sua mensagem. Entraremos em contato em 1 dia útil.',
  contact_form_success_btn: 'Enviar Outra',
  contact_form_name: 'Seu Nome',
  contact_form_name_placeholder: 'Digite seu nome',
  contact_form_phone: 'Número de Telefone',
  contact_form_phone_placeholder: 'Digite seu telefone',
  contact_form_email: 'Endereço de Email',
  contact_form_email_placeholder: 'Digite seu email',
  contact_form_inquiry: 'Tipo de Consulta',
  contact_form_company: 'Nome da Empresa',
  contact_form_company_optional: '(Opcional)',
  contact_form_company_placeholder: 'Digite o nome da empresa se aplicável',
  contact_form_message: 'Mensagem',
  contact_form_message_placeholder: 'Descreva suas necessidades ou perguntas em detalhes...',
  contact_form_required: '*',
  contact_form_error: 'Falha ao enviar. Tente novamente.',
  contact_form_sending: 'Enviando...',
  contact_form_submit: 'Enviar Mensagem',
  inquiry_type1: 'Consulta de Produto',
  inquiry_type2: 'Cooperação de Atacado',
  inquiry_type3: 'Serviço Pós-Venda',
  inquiry_type4: 'Cooperação de Mídia',
  inquiry_type5: 'Outros',

  // Contact CTA
  contact_cta_title: 'Ainda Tem Dúvidas?',
  contact_cta_desc: 'Confira nosso FAQ ou envie um email para',
  contact_cta_btn_browse: 'Ver Produtos',
  contact_cta_btn_email: 'Enviar Email',

  // Contact Info
  contact_info1_title: 'Endereço da Empresa',
  contact_info1_line1: 'FLAT /RM A 9/F SILVERCORP',
  contact_info1_line2: 'INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  contact_info1_action: 'Ver Mapa',
  contact_info2_title: 'Atendimento ao Cliente',
  contact_info2_line1: 'Atendimento ao Cliente',
  contact_info2_line2: 'Seg–Sex 9:00 – 18:00',
  contact_info2_action: 'Conversar Agora',
  contact_info3_title: 'Email',
  contact_info3_line1: 'cs@koorpet.com',
  contact_info3_line2: 'Negócios: cs@koorpet.com',
  contact_info3_action: 'Enviar Email',
  contact_info4_title: 'WhatsApp',
  contact_info4_line1: 'Koorpet Oficial',
  contact_info4_line2: 'Converse diretamente conosco pelo WhatsApp',
  contact_info4_action: 'Iniciar Conversa',

  // Footer
  footer_brand_desc: 'Dedicados à P&D e produção de arranhadores, dando a cada gato seu próprio território feliz.',
  footer_nav_title: 'Links Rápidos',
  footer_products_title: 'Linhas de Produtos',
  footer_product1: 'Arranhadores de Papelão',
  footer_product2: 'Postes de Sisal',
  footer_product3: 'Série Árvore para Gatos',
  footer_product4: 'Protetores de Canto',
  footer_product5: 'Série Catnip',
  footer_contact_title: 'Fale Conosco',
  footer_address: 'FLAT /RM A 9/F SILVERCORP INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  footer_phone: 'Seg–Sex 9:00 – 18:00',
  footer_whatsapp: 'WhatsApp',
  footer_email: 'cs@koorpet.com',
  footer_hours: 'Seg–Sex 9:00 – 18:00',
  footer_copyright: '© 2026 DANA INTERNATIONAL (HK) CO., LIMITED',
  footer_privacy: 'Política de Privacidade',
  footer_terms: 'Termos de Uso',
  footer_admin: 'Administração',

  // Legal Page
  legal_breadcrumb: 'Jurídico',
  legal_banner_title: 'Informações Legais',
  legal_banner_desc: 'Leia os termos a seguir com atenção para entender como protegemos seus direitos',
  legal_updated: 'Última atualização',

  // Privacy Policy
  privacy_s1_title: 'Sobre Esta Política',
  privacy_s1_p1: 'A DANA INTERNATIONAL (HK) CO., LIMITED (doravante "Koorpet" ou "nós") leva a privacidade do usuário muito a sério. Esta Política de Privacidade explica como coletamos, usamos, armazenamos e protegemos suas informações pessoais.',
  privacy_s1_p2: 'Ao usar nosso site, produtos ou serviços, você concorda com os termos desta Política de Privacidade. Se não concordar, interrompa o uso de nossos serviços.',
  privacy_s2_title: 'Informações que Coletamos',
  privacy_s2_p1: 'Para fornecer melhores serviços, podemos coletar os seguintes tipos de informações:',
  privacy_s2_li1: 'Informações de identidade: nome, número de telefone, endereço de email',
  privacy_s2_li2: 'Informações de transação: histórico de pedidos, endereço de entrega, detalhes de pagamento',
  privacy_s2_li3: 'Informações do dispositivo: endereço IP, tipo de navegador, sistema operacional',
  privacy_s2_li4: 'Dados de uso: registros de visita a páginas, comportamento de cliques, palavras-chave de pesquisa',
  privacy_s3_title: 'Como Usamos Suas Informações',
  privacy_s3_p1: 'As informações que coletamos serão usadas para os seguintes fins:',
  privacy_s3_li1: 'Processar seus pedidos e fornecer serviços pós-venda relacionados',
  privacy_s3_li2: 'Enviar atualizações de produtos e notificações promocionais (você pode cancelar a qualquer momento)',
  privacy_s3_li3: 'Melhorar a funcionalidade do nosso site e a experiência do usuário',
  privacy_s4_title: 'Compartilhamento e Divulgação de Informações',
  privacy_s4_p1: 'Não vendemos suas informações pessoais a terceiros. Podemos compartilhar suas informações nas seguintes circunstâncias:',
  privacy_s4_p2: 'Compartilhar informações de entrega com parceiros logísticos; cumprir requisitos legais; com sua autorização explícita.',
  privacy_s5_title: 'Segurança das Informações',
  privacy_s5_p1: 'Usamos medidas de segurança padrão do setor para proteger suas informações pessoais, incluindo transmissão criptografada SSL e controles de acesso a dados. Observe que a transmissão pela internet não é absolutamente segura e não podemos garantir a segurança absoluta da transmissão de informações.',
  privacy_s6_title: 'Seus Direitos',
  privacy_s6_p1: 'Você tem os seguintes direitos em relação às suas informações pessoais:',
  privacy_s6_li1: 'Direito de acesso: Você pode acessar suas informações pessoais mantidas por nós a qualquer momento',
  privacy_s6_li2: 'Direito de correção: Se as informações estiverem incorretas, você pode solicitar que as corrijamos',
  privacy_s6_li3: 'Direito de exclusão: Em certas circunstâncias, você pode solicitar que excluamos suas informações pessoais',
  privacy_s7_title: 'Fale Conosco',
  privacy_s7_p1: 'Se você tiver dúvidas sobre esta Política de Privacidade, entre em contato conosco:',

  // Terms of Use
  terms_s1_title: 'Aceitação dos Termos',
  terms_s1_p1: 'Bem-vindo ao site oficial da Koorpet. Ao acessar ou usar este site, você concorda em ficar vinculado a estes Termos de Uso.',
  terms_s1_p2: 'Reservamo-nos o direito de modificar estes termos a qualquer momento. Os termos modificados serão publicados no site e o uso continuado do site constitui aceitação dos termos modificados.',
  terms_s2_title: 'Produtos e Compras',
  terms_s2_p1: 'Ao comprar produtos através deste site, você deve cumprir o seguinte:',
  terms_s2_li1: 'Todas as informações fornecidas devem ser verdadeiras, precisas e completas',
  terms_s2_li2: 'Você deve ter pelo menos 18 anos ou usar o serviço com consentimento do responsável',
  terms_s2_li3: 'Os preços dos produtos podem mudar a qualquer momento; o preço exibido no momento do pedido é o que vale',
  terms_s3_title: 'Envio e Entrega',
  terms_s3_p1: 'Faremos todos os esforços para entregar os produtos dentro do prazo prometido, mas os tempos reais de entrega podem variar devido a condições logísticas.',
  terms_s3_p2: 'O escopo de entrega, taxas de envio e tempos estimados de chegada estão sujeitos ao que é exibido na página de checkout. Em caso de atrasos por força maior, notificaremos você prontamente.',
  terms_s4_title: 'Política de Devolução e Troca',
  terms_s4_p1: 'Estamos comprometidos em fornecer excelente serviço pós-venda. Nossa política de devolução e troca é a seguinte:',
  terms_s4_li1: 'Em até 7 dias após o recebimento do produto, se houver problema de qualidade, você pode solicitar devolução ou troca',
  terms_s4_li2: 'Os produtos devem estar na embalagem original, não utilizados e sem danos',
  terms_s4_li3: 'Os custos de envio de devolução são arcados pela parte responsável; se for problema de qualidade, arcamos com os custos de envio',
  terms_s5_title: 'Propriedade Intelectual',
  terms_s5_p1: 'Todo o conteúdo deste site, incluindo mas não limitado a textos, imagens, logotipos e designs de produtos, é protegido por leis de propriedade intelectual e pertence à Koorpet.',
  terms_s5_p2: 'Sem nossa permissão por escrito, você não pode copiar, modificar, distribuir ou usar qualquer conteúdo deste site de qualquer forma.',
  terms_s6_title: 'Aviso Legal',
  terms_s6_p1: 'O conteúdo deste site é apenas para referência. Não nos responsabilizamos por quaisquer perdas diretas ou indiretas decorrentes do uso deste site ou da confiança em suas informações. As imagens dos produtos são apenas para referência; o produto real recebido prevalece.',
  terms_s7_title: 'Lei Aplicável',
  terms_s7_p1: 'Estes Termos de Uso são regidos pelas leis da República Popular da China. Em caso de disputas, ambas as partes tentarão primeiro resolvê-las por negociação; se a negociação falhar, a disputa será submetida aos tribunais competentes em Hong Kong SAR.',
  terms_s8_title: 'Fale Conosco',
  terms_s8_p1: 'Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco:',
};

export default pt;